export function updateCoursePrices() {
    let updatePricesElements = document.querySelectorAll('.update-course-price');
    if (updatePricesElements) {
        let codes = [];
        updatePricesElements.forEach((element) => {
            let code = element.getAttribute('course-code');
            if (code && codes.indexOf(code) === -1) {
                codes.push(code);
            }
        })

        $.ajax({
            url: tech.core.getInternationalUrl('/Course/GetCoursePrices'),
            type: 'post',
            data: {
                courseCodes: codes,
            },
            success: function (data) {
                if (data && data.prices) {
                    updatePricesElements.forEach((element) => {
                        let priceDataCode = element.getAttribute('course-code');
                        if (priceDataCode) {
                            let priceInfo = findCardInfo(priceDataCode, data.prices);
                            if (priceInfo && priceInfo.priceFormat) {
                                element.innerHTML = priceInfo.priceFormat;
                            }
                        }
                    })

                    let datesResponse = document.querySelectorAll('.course-duration-date')
                    datesResponse.forEach((element) => {
                        const dateDataCode = element.getAttribute('course-code');
                        const dates = element.querySelectorAll('p span');
                        if (dateDataCode && dates.length === 2) {
                            let cardInfo = findCardInfo(dateDataCode, data.prices);
                            if (cardInfo && cardInfo.startDate && cardInfo.finishDate) {
                                dates[0].innerHTML = cardInfo.startDate;
                                dates[1].innerHTML = cardInfo.finishDate;
                            }
                        }
                    })
                }
            }
        })
    }
}

function findCardInfo(courseCode, dataInfo) {
    for (let i in dataInfo) {
        if (dataInfo[i].courseCode === courseCode) {
            return dataInfo[i];
        }
    }
    return '';
}